import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useFavorites } from "../../context/favoritesContext";
import MedicamentoCard from "../components/medicamentoCard";
import "./favorites.css";

export default function Favorites() {
  const { isAuth } = useAuth();
  const { favorites, loading } = useFavorites();

  if (!isAuth) {
    return (
      <div className="container favorites-page">
        <h1>Mis favoritos</h1>
        <p>Debes iniciar sesión para ver tus medicamentos favoritos.</p>
        <Link to="/login" className="btn btn-primary">
          Iniciar sesión
        </Link>
      </div>
    );
  }

  return (
    <div className="container favorites-page">
      <h1>Mis favoritos</h1>

      {loading && <div className="loading">Cargando favoritos…</div>}

      {!loading && favorites.length === 0 && (
        <p>No tienes medicamentos guardados. Marca la estrella en la búsqueda.</p>
      )}

      {!loading && favorites.length > 0 && (
        <div className="grid-cards">
          {favorites.map((fav) => {
            const m = fav.medicamento_id || {};
            return (
              <MedicamentoCard
                key={m._id}
                medicamento={m}
                favoritoId={m._id}
                nombre={m.nombre}
                activos={m.sustanciaActiva}
                precio={m.precio}
                imagen={m.enlaceImagen}
                enlace={`/detalles/${m._id}`}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
